"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bet = void 0;
var Bet;
(function (Bet) {
    Bet[Bet["UP"] = 0] = "UP";
    Bet[Bet["DOWN"] = 1] = "DOWN";
    Bet[Bet["DRAW"] = 2] = "DRAW";
})(Bet = exports.Bet || (exports.Bet = {}));
